import type { ReactNode } from 'react';
import { SizableText, XStack } from 'tamagui';

interface SectionHeaderProps {
  title: string;
  titleSlot?: ReactNode;
  rightSlot?: ReactNode;
  onPress?: () => void;
}

export const SectionHeader = ({
  title,
  titleSlot,
  rightSlot,
  onPress,
}: SectionHeaderProps): React.ReactElement => (
  <XStack
    alignItems="center"
    justifyContent="space-between"
    gap="$2"
    onPress={onPress}
    cursor={onPress ? 'pointer' : undefined}
    pressStyle={onPress ? { opacity: 0.7 } : undefined}
  >
    {titleSlot ?? (
      <SizableText size="$body" fontFamily="$bold" color="$color">
        {title}
      </SizableText>
    )}
    {rightSlot}
  </XStack>
);
